import QuickActions from '@components/dashboard/QuickActions';
import RecentStudies from '@components/dashboard/RecentStudies';
import StatisticsPanel from '@components/dashboard/StatisticsPanel';
import WelcomeBoard from '@components/dashboard/WelcomeBoard';
import EntitlementActivityCard from '@components/dashboard/EntitlementActivityCard';
import Spinner from '@components/spinner/Spinner';
import { useMixpanel } from '@context/MixpanelProvider';
import { Alert, Box } from '@mui/material';
import { DASHBOARD_EVENTS } from '@utils/eventSchema';
import { Suspense, useEffect } from 'react';
import PageContainer from 'src/components/PageContainer';
import ErrorBoundary from '../../components/ErrorBoundary';
import JoyrideTour from '../../hooks/JoyRideTour';
import { useWorkspaceUsage } from '@hooks/getQueries';
import useWorkspace from '@hooks/useWorkspace';

const Dashboard = () => {
  const { trackEvent } = useMixpanel();
  const { activeWorkspaceId } = useWorkspace();
  const { data: usageData } = useWorkspaceUsage(activeWorkspaceId);
  const entitlements = usageData?.entitlements || {};
  const configuredParticipants = entitlements.configured_interview_participants || 0;
  const remainingInterviewEntitlements = entitlements.ai_interviews_remaining;
  const showWorkspaceWarning =
    typeof remainingInterviewEntitlements === 'number' &&
    configuredParticipants > remainingInterviewEntitlements;

  // Track dashboard viewed event when component mounts
  useEffect(() => {
    trackEvent('dashboard', DASHBOARD_EVENTS.DASHBOARD_VIEWED);
  }, [trackEvent]);

  return (
    <>
      <JoyrideTour />
      <PageContainer title="Dashboard" description="Dashboard">
        <Box py={3} display="flex" flexDirection={'column'} gap={3}>
          <WelcomeBoard />

          {showWorkspaceWarning && (
            <Alert severity="warning" sx={{ mx: { xs: 2, md: 3 } }}>
              Your active interview studies are configured for {configuredParticipants} total
              participants, which exceeds your workspace&apos;s available voice interview
              entitlements ({remainingInterviewEntitlements}). Some participants may not be able to
              complete interviews. Please contact sales to increase entitlements.
            </Alert>
          )}

          <ErrorBoundary>
            <StatisticsPanel />
          </ErrorBoundary>

          <QuickActions />

          <Box px={{ xs: 2, md: 3 }}>
            <EntitlementActivityCard />
          </Box>

          <ErrorBoundary>
            <Suspense fallback={<Spinner />}>
              <RecentStudies />
            </Suspense>
          </ErrorBoundary>
        </Box>
      </PageContainer>
    </>
  );
};

export default Dashboard;
